<!--
 * @Descripttion: 
 * @Author: Gavin
 * @version: 
 * @Date: 2020-07-27 09:15:58
 * @LastEditTime: 2020-07-28 20:46:20
--> 
<template>
	<a href="javascript:;" class="store-back-btn" @click="handleBack">
		<img src="../../../assets/imgs/icon_nav_home.svg" alt="">
	</a>
</template>

<script>
	export default {
		methods:　{
			//返回
			handleBack() {
				this.$router.push({
					name: 'storeHome',
					params: {
						shopId: this.$route.params.shopId
					}
				})
				// if(window.history.length <= 1){
				// 	this.$router.push({
				// 		name: 'storeHome',
				// 		params: {
				// 			shopId: this.$route.params.shopId
				// 		}
				// 	})
				// }else{
				// 	this.$router.back(-1)
				// }
			}
		}
	}
</script>

<style lang="scss">
	.store-back-btn{
		position: fixed;
		bottom: 132px;
		right: 30px;
		width: 92px;
		height: 92px;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: #fff;
		box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.1);
		z-index: 99;

		img{
			display: block;
			width: 50px;
		}
	}
</style>